import { JSONLDMetadata } from "../types/crowdhandler";

const getCaptchaTypeFromMetadata = (metadata: JSONLDMetadata): string | null => {
    // const metadata = getJSONLDMetadata();
    if (metadata?.captchaType) {
        const captchaTypeMap = {
            recaptcha: "recaptcha",
            altcaptcha: "altcha",
            hcaptcha: "hcaptcha",
        } as const;  // Add 'as const' to make the type more specific

        // Type guard to check if the captchaType is a valid key
        const captchaType = metadata.captchaType.toLowerCase();
        if (captchaType in captchaTypeMap) {
            return captchaTypeMap[captchaType as keyof typeof captchaTypeMap];
        }
        return null;
    }
    return null;
};


export { getCaptchaTypeFromMetadata };